import { render } from "./OverflowPage.vue?vue&type=template&id=52cc6f6a&ts=true"
import script from "./OverflowPage.vue?vue&type=script&lang=ts"
export * from "./OverflowPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__